import {
  Box,
  Card,
  CardContent,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { axiosInstance } from "src/api/axios";

const AdminUsersTable = ({ user, shouldUpdateRole }) => {
  const [role, setRole] = useState();

  const updateRole = (id, role) => {
    if(!shouldUpdateRole){
      return;
    }
    axiosInstance
      .patch(`users/${id}`, {
        role,
      })
      .then((response) => {
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e.respose?.data?.message);
      });
  };
  return (
    <Box>
      <Card title="Joined Users" elevation={9} variant={"elevation"}>
        <CardContent>
          <Card sx={{ overflow: "auto", width: { xs: "280px", sm: "auto" } }}>
            <Table
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
                mt: 2,
              }}
              stickyHeader={true}
            >
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight={600}>
                      user_id
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight={600}>
                      Name
                    </Typography>
                  </TableCell>

                  <TableCell align="left">
                    <Typography variant="subtitle2" fontWeight={600}>
                      Email Verified
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="subtitle2" fontWeight={600}>
                      Mobile Verified
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight={600}>
                      Completed Leads
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight={600}>
                      Bank Account
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="subtitle2" fontWeight={600}>
                      Earned
                    </Typography>
                  </TableCell>
                  {shouldUpdateRole && (
                    <TableCell align="right">
                      <Typography variant="subtitle2" fontWeight={600}>
                        Role
                      </Typography>
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {user &&
                  user?.map((product, index) => (
                    <TableRow key={product.name}>
                      <TableCell sx={{ maxWidth: "120px", minWidth: "115px" }}>
                        <Typography
                          sx={{
                            fontSize: "15px",
                            fontWeight: "500",

                            wordBreak: "break-all",
                          }}
                        >
                          {product?.user_id || index}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            <Typography variant="subtitle2" fontWeight={600}>
                              {product.name}
                            </Typography>
                            <Typography
                              color="textSecondary"
                              sx={{
                                fontSize: "13px",
                              }}
                            >
                              {product.email || "Null"}
                            </Typography>
                            <Typography
                              color="textSecondary"
                              sx={{
                                fontSize: "13px",
                              }}
                            >
                              {product.date_joined || "Null"}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Chip
                          sx={{
                            px: "4px",
                            backgroundColor: product.isEmailVerified
                              ? "earnpati.main"
                              : "error.main",
                            color: "#fff",
                          }}
                          size="small"
                          label={product.isEmailVerified ? "✔" : "✖"}
                        ></Chip>
                      </TableCell>

                      <TableCell>
                        <Chip
                          sx={{
                            px: "4px",
                            backgroundColor: product.isPhoneVerified
                              ? "earnpati.main"
                              : "error.main",
                            color: "#fff",
                          }}
                          size="small"
                          label={product.isPhoneVerified ? "✔" : "✖"}
                        ></Chip>
                      </TableCell>

                      <TableCell align={"center"}>
                        <Typography
                          color="textSecondary"
                          variant="subtitle2"
                          fontWeight={400}
                        >
                          {product.completedLeadsCount ?? 0}
                        </Typography>
                      </TableCell>

                      <TableCell align="center">
                        <Typography variant="h6">
                          {product.bankAccount
                            ? product.bankAccount?.account_number
                            : "Null"}
                        </Typography>
                        <Typography variant="subtitle">
                          {product.bankAccount
                            ? product.bankAccount?.ifsc_code
                            : ""}
                        </Typography>
                        <p>
                          Valid:{" "}
                          {product.bankAccount
                            ? String(product.bankAccount?.valid)
                            : "-"}
                        </p>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="h6">
                          {product.wallet ? product.wallet.totalEarned : 0} INR
                        </Typography>
                      </TableCell>
                      {shouldUpdateRole && (
                      <TableCell align="right">
                        <FormControl sx={{ width: 95 }}>
                          <InputLabel id="user-role">Role</InputLabel>
                          <Select
                            labelId="user-role"
                            id="role"
                            label={product.role}
                            defaultValue={product.role}
                            name={product.email}
                            sx={{ flex: 2 }}
                            value={role}
                            onChange={(e) =>
                              updateRole(e.target.name, e.target.value)
                            }
                          >
                            <MenuItem value="user">User</MenuItem>
                            <MenuItem value="admin">Admin</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                      )}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Card>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdminUsersTable;
